import { render, staticRenderFns } from "./AdminManufacturerForm.vue?vue&type=template&id=739172e6"
import script from "./AdminManufacturerForm.vue?vue&type=script&lang=ts"
export * from "./AdminManufacturerForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports